import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { toNumber } from '@/shared/functions';
import { notification } from 'antd';
const initState = {
    notEqualToHandPrice: false,
    winningPrice: '',
    commission: '',
    servicePrice: '',
    handPrice: '',
    showTransferWay: true,
    showBrokeredDeal: false,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 撮合成交 */
        doBrokeredDeal(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                return Api.order.getMatchUp(payload).then((_r) => {
                    console.log('_r', _r);
                    return _r;
                }).catch((_e) => {
                    console.log('_e', _e);
                    return false;
                });
            });
        },
        /** 点击确定 */
        handleOk(payload, { update, state, rootState }) {
            const { orderId } = state;
            payload.form.validateFields((error, values) => {
                if (!error) {
                    // 校验合手价
                    this.checkHandPrice(payload).then((_r) => {
                        console.log('是否等于合手价', _r);
                        /** 等于合手价 */
                        if (_r) {
                            // 参数需要调整
                            const _params = {
                                orderId,
                                priorityOffer: values.winningPrice,
                                commission: values.servicePrice,
                                brokerage: values.commission,
                                remark: values.remark,
                                // 如果不展示过户方式的情况的，可以处理下不传过户方式，或者后端不care就ok
                                transferType: values.transferType ? values.transferType : '666',
                            };
                            // 请求撮合成交接口
                            this.doBrokeredDeal(_params).then((_r) => {
                                if (_r) {
                                    // 有 获取全部值 请求数据 成功后
                                    notification.success({
                                        message: '撮合成交成功',
                                    });
                                    this.CloseModal();
                                    this.RESET_STATE();
                                    payload.form.resetFields();
                                    state.callback && state.callback(state.orderId);
                                }
                                else {
                                    notification.success({
                                        message: '撮合成交失败',
                                    });
                                }
                            });
                        }
                        /** 不等于合手价 */
                        else {
                            this.SET_STATE({ notEqualToHandPrice: true });
                        }
                    });
                }
            });
        },
        /** 点击取消或叉号 */
        handleCancel(payload, { update, state, rootState }) {
            this.CloseModal();
        },
        /** 模态框关闭之后 */
        handleClose(payload, { update, state, rootState }) {
            payload.form.resetFields();
            this.RESET_STATE();
        },
        /** 校验 合手价 与 中标价+服务费+佣金 关系； 不相等则抛错 */
        checkHandPrice(payload, { update, state, rootState }) {
            return new Promise((resolve) => {
                // const { priceObj } = payload;
                const { handPrice } = state;
                const { winningPrice, servicePrice, commission } = payload.form.getFieldsValue();
                const sum = [winningPrice, servicePrice, commission].reduce((preValue, curValue) => {
                    return toNumber(preValue) + toNumber(curValue);
                });
                // 中标价+服务费+佣金 与 合手价 是否相等 => true 相等 false 不相等
                if (toNumber(handPrice) !== sum) {
                    payload.form.setFields({
                        winningPrice: { value: winningPrice, errors: [new Error(' ')] },
                        servicePrice: { value: servicePrice, errors: [new Error(' ')] },
                        commission: { value: commission, errors: [new Error(' ')] },
                    });
                    resolve(false);
                }
                resolve(true);
            });
        },
        // 使用组件方式引用MembersList
        dealUseComponent(payload) {
            this.SET_STATE_USE_COMPONENT(payload);
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                state[key] = payload[key];
            });
        },
        ShowModal(state, { winningPrice, commission, servicePrice, handPrice, showTransferWay, orderId, callback }) {
            state.showBrokeredDeal = true;
            state.winningPrice = winningPrice,
                state.commission = commission,
                state.servicePrice = servicePrice,
                state.handPrice = handPrice,
                showTransferWay !== undefined ? state.showTransferWay = showTransferWay : '';
            state.orderId = orderId;
            state.callback = callback;
        },
        CloseModal(state) {
            state.showBrokeredDeal = false;
        },
        // 使用组件方式引用MembersList, 父组件props赋值给state
        SET_STATE_USE_COMPONENT(state, payload) {
            // 如果payload里属性均有定义，则赋值
            const { visibleUseComponent, objUseComponent } = payload;
            if (visibleUseComponent !== undefined && objUseComponent !== undefined) {
                state.showBrokeredDeal = visibleUseComponent;
                const { orderId, winningPrice, commission, servicePrice, handPrice, showTransferWay, onOk } = objUseComponent || {};
                state.orderId = orderId;
                state.winningPrice = winningPrice;
                state.commission = commission;
                state.servicePrice = servicePrice;
                state.handPrice = handPrice;
                showTransferWay !== undefined ? state.showTransferWay = showTransferWay : '';
                state.callback = onOk;
            }
        },
    },
});
